import * as React from 'react';

import { Box, FormControl } from '@fhs-legacy/universal-components';

import { InputMessage } from '../input-message';

import { IFieldSetProps } from './types';

/**
 * Groups several form fields and their labels together
 */
const FieldSet: React.FC<React.PropsWithChildren<IFieldSetProps>> = ({
  disabled,
  label,
  children,
  errorMessage,
  hintMessage,
  messageId: messageIdProp,
  testID,
  ...props
}) => {
  const defaultMessageId = React.useId();
  const messageId = messageIdProp || defaultMessageId;

  return (
    <Box width="full" p="0" m="0" accessibilityLabel="group" {...props}>
      <FormControl.Label isDisabled={disabled}>{label}</FormControl.Label>
      {children}
      <InputMessage disabled={disabled} id={messageId} hasError={!!errorMessage} testID={testID}>
        {!errorMessage && hintMessage}
      </InputMessage>
    </Box>
  );
};

export default FieldSet;
